module.exports = __webpack_public_path__ + "static/media/1.63e7ef1c.jpg";